module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAAUFJREFUSIntlaFOA0EQhr9ZEkJ4CFJTAxYMpouh9wK94LB4CEiOhKBAVPIG5HiB0oSwWNCgKsDzBIhbBLT0yvV22h6q/eXc3P/tbHZmYKEC2WjPTvuvTARqxpfA4Uj4yt2lR1qPJW1iI4ovBI4LPm2v1ddX3nuv9xofVYU2ihM8p+VOZsd1blzIy2iAPvOrpSzIyLJzjZcKKCK29EBgEJarA4IX+AykPVUG9GJOPIEKhA+Nl7ot7G7rGZHN4hNx7brpgcZHVSGA695ugW8X0NpaGEzY+H3ZKE7AOABNK8yXxl5pfkBndlzeXxlXds2FQNtsPUB5swclnLlOmgSBNoodnsZMsF/3R9dJ7XAoty1+hvR+JbBv1Wr1DXnrvbh+IN+HoY0wjUY8B8BZtnhIw97qSVOVFsDKlevD/3o48zXgvwDAulP+hPj/RAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/user.png
// module id = +yhB
// module chunks = 171